"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcActionDropdown_1 = require("../../dropdown/AcActionDropdown");
exports.AcStampButtonDropdown = function (_a) {
    var dropdownProps = _a.dropdownProps, dropdownData = _a.dropdownData;
    return (react_1.default.createElement("div", { className: "position-absolute", style: { right: 0, top: 0, width: '30px', height: '30px' }, onClick: function (e) {
            e.stopPropagation();
        } },
        react_1.default.createElement(AcActionDropdown_1.AcActionDropdown, __assign({}, dropdownProps, { data: dropdownData }))));
};
exports.AcStampButtonDropdown.displayName = 'AcStampButtonDropdown';
//# sourceMappingURL=AcStampButtonDropdown.js.map